import React, { useState, useRef, useEffect } from 'react'

import "./Dropdown.css"

const Dropdown = ({ placeholder, options, value, onChange, required }) => {
    const [open, setOpen] = useState(false)
    const ref = useRef(null)
    const validityRef = useRef(null)

    useEffect(() => {
        const handlePointer = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false)
        }
        const handleKey = (e) => {
            if (e.key === "Escape") setOpen(false)
        }
        document.addEventListener('mousedown', handlePointer)
        document.addEventListener('keydown', handleKey)
        return () => {
            document.removeEventListener('mousedown', handlePointer)
            document.removeEventListener('keydown', handleKey)
        }
    }, [])

    const select = (val) => {
        onChange(val)
        setOpen(false)
    }

    return (
        <div
            className={`dropdown${open ? " open" : ""}${value ? " filled" : ""}`}
            ref={ref}
        >
            <button
                type="button"
                className="dropdown-trigger"
                onClick={() => setOpen(o => !o)}
                aria-haspopup="listbox"
                aria-expanded={open}
            >
                <span className="dropdown-value">{value || placeholder}</span>
                <svg className="dropdown-arrow" viewBox="0 0 24 24" fill="none">
                    <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2"
                        strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>

            <ul className="dropdown-menu" role="listbox">
                {options.map(opt => (
                    <li
                        key={opt}
                        role="option"
                        aria-selected={value === opt}
                        className={`dropdown-option${value === opt ? " selected" : ""}`}
                        onClick={() => select(opt)}
                    >
                        {opt}
                    </li>
                ))}
            </ul>

            {/* Keeps native form validation working for this required control */}
            <input
                ref={validityRef}
                className="dropdown-validity"
                tabIndex={-1}
                aria-hidden="true"
                required={required}
                value={value}
                onChange={() => {}}
                onFocus={() => setOpen(true)}
            />
        </div>
    )
}

export default Dropdown
